/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import Raven from 'raven-js';
import userInfo from 'hub-http/userInfo';
import { useCallback, useEffect, useState } from 'react';
import http from 'hub-http/clients/apiClient';
const clientInfoDefault = {
  gates: [],
  limits: {},
  scopes: [],
  userId: undefined,
  portalId: undefined,
  currencyCode: 'USD',
  isUserInfoFetched: false
};
const fetchHomeCurrency = () => http.get(`multi-currency/v2/currencies/information`, {}).then(response => {
  var _response$homeCurrenc;
  const code = response === null || response === void 0 || (_response$homeCurrenc = response.homeCurrency) === null || _response$homeCurrenc === void 0 ? void 0 : _response$homeCurrenc.currencyCode;
  if (code) {
    return code;
  }
  throw new Error(`Response does not contain a currency code: ${JSON.stringify(response)}`);
}).catch(error => {
  Raven.captureException(error);
  return clientInfoDefault.currencyCode;
});
export const useClientInfo = () => {
  const [clientInfo, setClientInfo] = useState(clientInfoDefault);
  useEffect(() => {
    Promise.all([userInfo(), fetchHomeCurrency()]).then(([userInfoData, currencyCode]) => {
      const {
        gates,
        user: {
          scopes,
          user_id
        },
        portal: {
          limits,
          portal_id
        }
      } = userInfoData;
      setClientInfo({
        gates,
        limits,
        scopes,
        userId: user_id,
        portalId: portal_id,
        currencyCode,
        isUserInfoFetched: true
      });
    });
  }, []);
  const getIsUngated = useCallback(gate => clientInfo.gates.includes(gate), [clientInfo.gates]);
  const hasScope = useCallback(scope => clientInfo.scopes.includes(scope), [clientInfo.scopes]);
  const hasLimit = useCallback(limit => clientInfo.limits[limit], [clientInfo.limits]);
  return {
    userId: clientInfo.userId,
    portalId: clientInfo.portalId,
    getIsUngated,
    hasLimit,
    hasScope,
    isUserInfoFetched: clientInfo.isUserInfoFetched,
    currencyCode: clientInfo.currencyCode
  };
};